<template>
  <div class="main">
    <div class="productsStyle">
      <ProductsInStockSidebar
        :article-list="articleList"
        @articleNumber="theArticleNumber"
        @resetAllArticles="resetAllArticless"
      />
      <ProductsInStockLocationsSidebar
        :article-list="articleList"
        :article-name="articleName"
        @addToOrder="addToOrders"
      />
    </div>
  </div>
</template>

<script>
import ProductsInStockSidebar from '@/components/productsInStock/ProductsInStockSidebar.vue'
import ProductsInStockLocationsSidebar from '@/components/productsInStock/ProductsInStockLocationsSidebar.vue'
import { mapActions } from 'vuex'

export default {
  components: {
    ProductsInStockSidebar,
    ProductsInStockLocationsSidebar,
  },
  data() {
    return {
      articleList: [],
      tabIndex: null,
      articleName: null,
    }
  },
  methods: {
    ...mapActions(['loadProductInStockList', 'resetTotalStockGroupedByLocation', 'sellableProducts']),
    theArticleNumber(value) {
      this.articleName = value
    },
    inStock() {
      this.loadProductInStockList({
        articleNumber: null,
        state: 'Recycle',
        pageNumber: 1,
        pageSize: 15,
      })
    },
    addToOrders(value) {
      const existingArticleIndex = this.articleList.findIndex(
        (item) => { return item.articleNumber === value.articleNumber && item.locationId === value.locationId },
      );
      if (existingArticleIndex !== -1) {
        this.articleList[existingArticleIndex].quantity += value.quantity;
      } else {
        this.articleList.push({
          ...value,
        });
      }
    },
    resetAllArticless() {
      this.articleList = []
    },
  },
}

</script>

  <style>
  .main {
    display: flex;
    gap: 10px;
  }
  .productsStyle {
    display: flex;
    gap:10px;
    width:100%
  }
  @media screen and (max-width: 1200px){
    .productsStyle {
    display: flex;
    flex-direction:column;
    gap:10px;
    width:100%
  }
}
  </style>
